export default "__VITE_ASSET__CQTKopUi__"